module.exports = __webpack_public_path__ + "img/unauthorized-artwork.9163db54.png";